import axios from "axios";
const baseUrl = process.env.REACT_APP_API_URL;

const apiConfig = axios.create({
  baseURL: baseUrl,
  headers: { "Content-Type": "application/json" },
});

export { apiConfig };
